import { render, staticRenderFns } from "./ResetPasswordPanel.vue?vue&type=template&id=5989da47&"
import script from "./ResetPasswordPanel.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports